import agent from "../../../api/agent";
export const list = (pagerInputModel)                => agent.requests.post(`/FairDetail/getlist`, pagerInputModel);
export const allFairList = (pagerInputModel)                => agent.requests.post(`/Fair/getpagedlist`, pagerInputModel);
export const allFairDetailList = (pagerInputModel)                => agent.requests.post(`/FairDetail/GetByFairId`, pagerInputModel);


export const create = (FairDetail)                => agent.requests.post(`/FairDetail/create`, FairDetail);
export const update = (FairDetail)                => agent.requests.post(`/FairDetail/update`, FairDetail);
export const deleteSector = (FairDetail)          => agent.requests.post(`/FairDetail/delete`, FairDetail);